import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import ImageWithLoader2 from './components/ImageWithLoader2';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';

function FamilySettings() {
  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

  const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
  
  const queryClient = useQueryClient();

  const [familyModalOpen, setFamilyModalOpen] = useState(false);
  const [selectedMember, setSelectedMember] = useState({
    name: "",
    alt_name: "",
  });

  const openModalWithData = (memberData) => {
    setSelectedMember({ ...memberData });
    setFamilyModalOpen(true);
  };


  const { data: familyDetails, isLoading, isError } = useQuery({
    queryKey: ['familyDetails'],
    queryFn: () =>
      axios.get(`${API_URL}/family-name-settings-api`, { withCredentials: true })
        .then(res => res.data.family_details),
    staleTime: 0,
    cacheTime: Infinity,
  });

  

  const handleUpdateFamily = async () => {
    if (!selectedMember.name ) {//|| !selectedMember.alt_name
      toast.error("Family name required.", { position: "top-right", autoClose: 3000 });
      return;
    }

    try {
      const res = await axios.put(`${API_URL}/update-family-name-settings-api`, selectedMember, {
        withCredentials: true,
      });

      if (res.data.success) {
        toast.success("Family details updated successfully", { position: "top-right", autoClose: 3000 });

        // Refetch the familyDetails query
        queryClient.invalidateQueries(['familyDetails']);

        setFamilyModalOpen(false);
        
      } else {
        toast.error("Update failed. Please try again.", { position: "top-right", autoClose: 3000 });
      }
    } catch (err) {
      console.error(err);
      toast.error("An error occurred while updating.", { position: "top-right", autoClose: 3000 });
    }
  };


  const {
    data: detailedFamily,
    isLoading: isDetailedLoading,
    isError: isDetailedError,
  } = useQuery({
    queryKey: ['familyDetailsExtended'],
    queryFn: () =>
      axios.get(`${API_URL}/family-details-settings-api`, { withCredentials: true })
        .then(res => res.data), // return entire object
    staleTime: 0,
    cacheTime: Infinity,
  });


 


  const [familyHistoryModalOpen, setFamilyHistoryModalOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');

  const handleSaveFamilyDescription = () => {
    if (!title.trim() || !description.trim()) {
      toast.error("Both title and description are required");
      return;
    }
  
    axios.post(`${API_URL}/save-family-hitory-settings-api`, {
      title,
      description
    }, { withCredentials: true })
      .then(() => {
        toast.success("Family history saved successfully");
        setFamilyHistoryModalOpen(false);
        setTitle('');
        setDescription('');

        queryClient.invalidateQueries(['familyHistorySettings']);
     
      })
      .catch(err => {
        console.error("Error saving family description:", err);
        toast.error("Error saving family description");
      });
  };

  
  const [historyList, setHistoryList] = useState([]);

  const {
    data: familyHistoryData,
    isLoading: isFamilyHistoryLoading,
    isError: isFamilyHistoryError,
    refetch: refetchFamilyHistory
  } = useQuery({
    queryKey: ['familyHistorySettings'],
    queryFn: () =>
      axios.get(`${API_URL}/get-family-history-settings-api`, { withCredentials: true })
        .then(res => res.data), // you can return res.data.data directly if needed
    staleTime: 0,
    cacheTime: Infinity,
  });

  useEffect(() => {
    if (familyHistoryData?.success) {
      setHistoryList(familyHistoryData.data);
    }
  }, [familyHistoryData]);

  

const [editFamHistModalOpen, setFamHistEditModalOpen] = useState(false);
const [editTitle, setEditTitle] = useState('');
const [editDescription, setEditDescription] = useState('');
const [editId, setEditId] = useState(null);

const openFamilyHistoryEditModal = (item) => {
  setEditTitle(item.title);
  setEditDescription(item.description);
  setEditId(item.id);
  setFamHistEditModalOpen(true);
};

  const handleUpdateFamilyDescription = () => {
    if (!editTitle.trim() || !editDescription.trim()) {
      toast.error("Both title and description are required");
      return;
    }
  
    axios.put(`${API_URL}/update-family-history-settings-api/${editId}`, {
      title: editTitle,
      description: editDescription
    }, { withCredentials: true })
      .then(() => {
        toast.success("Family history updated successfully");
        setFamHistEditModalOpen(false);
        setEditId(null);
        setEditTitle('');
        setEditDescription('');
        //refreshHistory();
        queryClient.invalidateQueries(['familyHistorySettings']);
      })
      .catch(err => {
        console.error("Error updating family description:", err);
        toast.error("Error updating family description");
      });
  };


  const [confirmModalOpen, setConfirmModalOpen] = useState(false);
  const [pendingDeleteId, setPendingDeleteId] = useState(null);

  const askDeleteConfirmation = (id) => {
    setPendingDeleteId(id);
    setConfirmModalOpen(true);
  };
  
  const confirmDelete = () => {
    axios.delete(`${API_URL}/delete-family-history-settings-api/${pendingDeleteId}`, { withCredentials: true })
      .then(() => {
        toast.success("Family history deleted successfully");
        queryClient.invalidateQueries(['familyHistorySettings']);
      })
      .catch(err => {
        console.error("Error deleting family description:", err);
        toast.error("Error deleting family description");
      })
      .finally(() => {
        setConfirmModalOpen(false);
        setPendingDeleteId(null);
      });
  };
  

  
  const {
    data: clanDescriptionData,
    isLoading: isClanDescriptionLoading,
    isError: isClanDescriptionError,
    refetch: refetchClanDescription
  } = useQuery({
    queryKey: ['clanDescriptionSettings'],
    queryFn: () =>
      axios.get(`${API_URL}/get-clan-description-settings-api`, { withCredentials: true })
        .then(res => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });
  
  const [clanDescription, setClanDescription] = useState(null);
  
  useEffect(() => {
    if (clanDescriptionData?.success) {
      setClanDescription(clanDescriptionData.data);
    }
  }, [clanDescriptionData]);


  const [isClanModalOpen, setIsClanModalOpen] = useState(false);
const [editClanDesc, setEditClanDesc] = useState('');
const [editDescId, setEditDescId] = useState(null);

// Function to open modal with existing description
const openClanDescriptionModal = (desc) => {
  setEditClanDesc(desc.description);
  setEditDescId(desc.description_id); // or `id`
  setIsClanModalOpen(true);
};

const [isUpdating, setIsUpdating] = useState(false);

const handleUpdateClanDescription = () => {
  if (!editClanDesc.trim()) {
    toast.error("Description cannot be empty");
    return;
  }

  setIsUpdating(true); // Disable button while updating

  axios.put(
    `${API_URL}/update-clan-description-settings-api/${editDescId}`,
    { description: editClanDesc },
    { withCredentials: true }
  )
    .then(() => {
      toast.success("Clan description updated");
      setIsClanModalOpen(false);
      queryClient.invalidateQueries(['clanDescriptionSettings']);
    })
    .catch(err => {
      console.error("Update failed", err);
      toast.error("Failed to update clan description");
    })
    .finally(() => {
      setIsUpdating(false); // Re-enable button
    });
};
  
  

const { data: familyAdminList, isLoadingAdmin, isErrorAdmin } = useQuery({
  queryKey: ['familyAdmin'],
  queryFn: () => axios.get(`${API_URL}/family-admin-list`).then((res) => res.data),
  staleTime: 0,
  cacheTime: Infinity,
});





const {
  data: traditionsDosDonts,
  isLoading: dosdontsLoading,
  isError: dosdontsError
} = useQuery({
  queryKey: ['traditionsDosDonts'],
  queryFn: () =>
    axios.get(`${API_URL}/get-family-traditions-api`, { withCredentials: true })
      .then(res => res.data.traditions),
  staleTime: 0,
  cacheTime: Infinity,
});

const dos = traditionsDosDonts?.filter(item => item.category === "dos") || [];
const donts = traditionsDosDonts?.filter(item => item.category === "donts") || [];


const [traditions, setTraditions] = useState('');

  const handleAddDo = () => {
    if (  !traditions.trim()) {
      toast.error("description is required");
      return;
    }
  
    axios.post(`${API_URL}/save-family-traditions-dos-api`, {
      
      traditions
    }, { withCredentials: true })
      .then(() => {
        toast.success("DO's saved successfully");
       
        setTraditions('');

        queryClient.invalidateQueries(['traditionsDosDonts']);
     
      })
      .catch(err => {
        console.error("Error saving DO's:", err);
        toast.error("Error saving DO's");
      });
  };


  

  const handleAddDonts = () => {
    if (  !traditions.trim()) {
      toast.error("description is required");
      return;
    }
  
    axios.post(`${API_URL}/save-family-traditions-donts-api`, {
      
      traditions
    }, { withCredentials: true })
      .then(() => {
        toast.success("DONT's saved successfully");
       
        setTraditions('');

        queryClient.invalidateQueries(['traditionsDosDonts']);
     
      })
      .catch(err => {
        console.error("Error saving DONT's:", err);
        toast.error("Error saving DONT's");
      });
  };


  const [traditionEditModalOpen, setTraditionEditModalOpen] = useState(false);
const [editTradition, setEditTradition] = useState('');
const [traditionId, setTraditionId] = useState(null);


const openTraditionEditModal = (item) => {
  setTraditionId(item.id);
  setEditTradition(item.traditions);
  setTraditionEditModalOpen(true);
};


  const handleEditDos = () => {
    if (!editTradition.trim()) {
      toast.error("Description is required");
      return;
    }
  
    axios.put(`${API_URL}/update-family-traditions-api/${traditionId}`, {
      traditions: editTradition
    }, { withCredentials: true })
      .then(() => {

        queryClient.invalidateQueries(['traditionsDosDonts']);

        toast.success("Description updated successfully");
        setTraditionEditModalOpen(false);
        setEditTradition("");
        setTraditionId(null);
  
        
      })
      .catch(err => {
        console.error("Error updating DO:", err);
        toast.error("Error updating DO");
      });
  };


  const handleDeleteDos = (id) => {
    axios.delete(`${API_URL}/delete-family-tradition-api/${id}`, { withCredentials: true })
      .then(() => {
        queryClient.invalidateQueries(['traditionsDosDonts']);
        toast.success("Description removed");
      })
      .catch(err => {
        console.error("Error deleting DO:", err);
        toast.error("Error deleting DO");
      });
  };




  //generation

  // Function to add suffix: 1st, 2nd, 3rd, 4th, etc.
const formatGeneration = (count) => {
  if (!count) return '--';

  const j = count % 10,
        k = count % 100;

  if (k >= 11 && k <= 13) {
    return count + 'th';
  }

  switch (j) {
    case 1: return count + 'st';
    case 2: return count + 'nd';
    case 3: return count + 'rd';
    default: return count + 'th';
  }
};

  const { data: familyGeneration, isLoadingGeneration, isErrorGeneration } = useQuery({
    queryKey: ['familyGeneration'],
    queryFn: () =>
      axios.get(`${API_URL}/family-number-generations`).then(res => res.data),
    staleTime: 0,
    cacheTime: Infinity,
  });
  
  // Optional: format with suffix
  const formattedTotalGenerations = familyGeneration
    ? formatGeneration(familyGeneration.total_generations)
    : '--';


    //number of family members

    const { data: familyMembers, isLoadingMembers, isErrorMembers } = useQuery({
      queryKey: ['familyMembersCount'],
      queryFn: () =>
        axios.get(`${API_URL}/family-number-of-members`).then(res => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });
    
    const totalMembers = familyMembers?.total_members || 0;


  if (isDetailedError) return <p>Error fetching detailed family info.</p>;

 

  return (
    <div className='scrollPageContainer theme-light'>
      <div className='main-wrapper'>
        {isSidebarVisible && <Sidebar />}
        <Header toggleSidebar={toggleSidebar} />
        <Sidebar show={showSidebar} toggle={toggleSidebar} />
        <Footerbar toggleSidebar={toggleSidebar} />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid px-1 px-md-4'>

          


            <div className="row">
            <div className="col-md-12">
            {Array.isArray(familyDetails) && familyDetails.map((family, index) => (
                  <div key={index}>
            <div className="card shadow border-0 rounded-3 overflow-hidden mb-4">
              <div
                className="position-relative text-center py-3 px-3"
                style={{
                  background:
                    'linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%)',
                  color: '#fff',
                }}
              >
                <h1
                  className="fs-3 fw-bold mt-2 mb-1 text-white"
                  style={{ textShadow: '0 3px 10px rgba(0,0,0,.45)' }}
                >
                  {family.name === '—' ? 'Our Family' : family.name}
                </h1>

                {family.alt_name !== '—' && (
                  <p
                    className="fs-5 mb-1"
                    style={{
                      color: '#fff',
                      textShadow:
                        '0 2px 6px rgba(0,0,0,.3)',
                      fontStyle: 'italic',
                    }}
                  >
                    {family.alt_name}
                  </p>
                )}

                <div
                  className="mb-0"
                  style={{ fontSize: 10, letterSpacing: 4 }}
                >
                  <span
                    className="mx-1"
                    style={{
                      color:
                        'rgba(255,255,255,0.9)',
                    }}
                  >
                    ●
                  </span>
                  <span
                    className="mx-1"
                    style={{
                      color:
                        'rgba(255,255,255,0.6)',
                    }}
                  >
                    ●
                  </span>
                  <span
                    className="mx-1"
                    style={{
                      color:
                        'rgba(255,255,255,0.4)',
                    }}
                  >
                    ●
                  </span>
                </div>
              </div>

              <div className="card-body text-center pt-3">
                <p
                  className="mt-3 mb-0"
                  style={{
                    maxWidth: 820,
                    marginInline: 'auto',
                  }}
                >
                  Welcome to{' '}
                  <b>
                    {family.name === '—'
                      ? 'our family space'
                      : family.name}
                  </b>
                  ! Here, we connect and grow
                  closer as a family. Let&apos;s
                  make lasting moments, building
                  a stronger and more connected{' '}
                  <b>
                    {family.name === '—'
                      ? 'family'
                      : family.name}
                  </b>
                  .
                </p>

                <div className="row g-3 mt-3 justify-content-center">
                  <div className="col-4 col-md-2">
                    <div
                      className="text-center h-100 d-flex flex-column justify-content-center"
                        style={{
                          background: '#fff',
                          borderRadius: 14,
                          padding: '14px 10px',
                          borderTop: '3px solid #75B437',
                          boxShadow:
                            '0 12px 24px rgba(0,0,0,.06),0 4px 10px rgba(24,74,44,.10)',
                        }}
                      >
                        <div
                          className="fw-bold mb-1"
                          style={{
                            fontSize: 18,
                            color: '#184A2C',
                          }}
                        >
                          {totalMembers}
                        </div>
                        <div
                          className="text-uppercase small"
                          style={{
                            letterSpacing: 1.5,
                            color: '#75B437',
                          }}
                        >
                         Members
                        </div>
                    </div>
                  </div>

                  <div className="col-4 col-md-3">
                    <div
                      className="text-center h-100 d-flex flex-column justify-content-center"
                        style={{
                          background: '#fff',
                          borderRadius: 14,
                          padding: '14px 10px',
                          borderTop: '3px solid #75B437',
                          boxShadow:
                            '0 12px 24px rgba(0,0,0,.06),0 4px 10px rgba(24,74,44,.10)',
                        }}
                      >
                        <div
                          className="fw-bold mb-1"
                          style={{
                            fontSize: 20,
                            color: '#184A2C',
                            lineHeight: 1.3,
                          }}
                        >
                        0
                      </div>
                        <div
                          className="text-uppercase small"
                          style={{
                            letterSpacing: 1.5,
                            color: '#75B437',
                          }}
                        >
                         EST
                        </div>
                    </div>
                  </div>

                  <div className="col-4 col-md-3">
                    <div
                      className="text-center h-100 d-flex flex-column justify-content-center"
                        style={{
                          background: '#fff',
                          borderRadius: 14,
                          padding: '14px 10px',
                          borderTop: '3px solid #75B437',
                          boxShadow:
                            '0 12px 24px rgba(0,0,0,.06),0 4px 10px rgba(24,74,44,.10)',
                        }}
                      >
                        <div
                          className="fw-bold mb-1"
                          style={{
                            fontSize: 20,
                            color: '#184A2C',
                          }}
                        >
                          {formattedTotalGenerations}
                        </div>
                        <div
                          className="text-uppercase small"
                          style={{
                            letterSpacing: 1.5,
                            color: '#75B437',
                          }}
                        >
                         Gen
                        </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

                </div>
                ))}
            </div>
            </div>

            <div className="row">
              <div className="col-md-12">

              {Array.isArray(familyDetails) && familyDetails.map((family, index) => (
                  <div key={index}>

                {/* Family Name */}
                <div className="info-card-mock">
                  <div className="card-header-section-mock">
                    <div className="card-icon-mock">
                      <i className="fas fa-id-card" />
                    </div>
                    <div className="card-actions-mock">

                    {loggedFamilyAdmin === "1" && (
                      <button
                        className="btn-edit-mock"
                        title="Edit Family Names"
                        onClick={() => openModalWithData(family)}
                      >
                        <i className="fas fa-pen" />
                      </button>
                      )}

                    </div>
                  </div>
                  <div className="card-title-mock">
                    Family Name
                  </div>
                  <div className="card-value-mock">
                    {family.name}
                  </div>
                </div>
                

                </div>
                ))}


                <ReactModal isOpen={familyModalOpen} onRequestClose={() => setFamilyModalOpen(false)} 
                  className="Modal" overlayClassName="Overlay">
                  
                  <div className="modal-header modal-header-green">
                    <h5 className="modal-title">Edit Family Details</h5>
                    <button type="button" className="btn-close modalCloseButton" onClick={() => setFamilyModalOpen(false)}></button>
                  </div>
                
                  <div className="modal-body" >
                    <div className="row">
                      <div className="col-12 col-md-12">
                      <label className="form-label small">
                            Family Name
                          </label>
                        <input
                          type="text"
                          name="family_name"
                          value={selectedMember.name}
                          onChange={(e) =>
                            setSelectedMember({
                              ...selectedMember,
                              name: e.target.value,
                            })
                          }
                          className="form-control mb-2"
                          required
                        />
                
                            <label className="form-label small">
                            Alternative / Nickname
                          </label>
                        <input
                          type="text"
                          name="alt_family_name"
                          value={selectedMember.alt_name}
                          onChange={(e) =>
                            setSelectedMember({
                              ...selectedMember,
                              alt_name: e.target.value,
                            })
                          }
                          className="form-control mb-2"
                          required
                        />
                      </div>
                    </div>
                  </div>
                
                  <div className="modal-footer">
                    <button className="btn btn-success" onClick={handleUpdateFamily}>
                      Update Details
                    </button>
                  </div>
                </ReactModal>

              </div>
            </div>

            <div class="row">
              
              {isDetailedLoading ? (
                  <div className="loadingspinnerDiv">
                    <div className="loadingspinner"></div>
                  </div>
                ) : (
                  detailedFamily && (
                    
                    <div class="col-12 col-md-12">
                      
                      {detailedFamily?.tribe_name && (
                    <div className="info-card-mock  mt-3">
                  <div className="card-header-section-mock">
                    <div className="card-icon-mock">
                      <i className="fas fa-people-group" />
                    </div>
                  </div>
                  <div className="card-title-mock">
                    Tribe
                  </div>
                  <div className="card-value-mock">
                    {detailedFamily?.tribe_name}
                  </div>
                </div>
                  )}


                    {detailedFamily?.sub_tribe_name && (
                  <div className="info-card-mock  mt-3">
                  <div className="card-header-section-mock">
                    <div className="card-icon-mock">
                      <i className="fas fa-sitemap" />
                    </div>
                  </div>
                  <div className="card-title-mock">
                    Sub-tribe
                  </div>
                  <div className="card-value-mock">
                    {detailedFamily?.sub_tribe_name}
                  </div>
                </div>
                  )}


                    <div className="info-card-mock mt-3">
                  <div className="card-header-section-mock">
                    <div className="card-icon-mock">
                      <i className="fas fa-users-rectangle" />
                    </div>

                    <div className="card-actions-mock">
                    {loggedFamilyAdmin === "1" && (
                      <Link to='/family-settings-edit-clan' 
                      className="btn-edit-mock"
                      style={{ background: 'transparent',  }}> 
                        <i className="fas fa-pen"></i></Link>
                      )}

                    </div>
                    </div>

                  <div className="card-title-mock">Clan</div> 
                  <div className="card-value-mock">
                    {detailedFamily?.clan_name}
                  </div>
                </div>



                <div className="info-card-mock mt-3 mb-3">
                  <div className="card-header-section-mock">
                    <div className="card-icon-mock">
                      <i className="fas fa-users-rectangle" />
                    </div>

                    <div className="card-actions-mock">
                    {loggedFamilyAdmin === "1" && (
                  
                  <Link to='/family-settings-edit-totem'  className="btn-edit-mock"
                        style={{ background: 'transparent', border: 'none',  }}> 
                        <i className="fas fa-pen" /></Link>
                
                    )}

                    </div>
                    </div>

                  <div className="card-title-mock">Totem</div> 
                  <div className="card-value-mock">
                     
                  </div>


                  {detailedFamily?.totem_image && (

                    
  <div className="totem-content-mock">
    <div className="totem-image-section-mock">
      <div className="totem-image-container-mock">
        <img
          src={`${API_URL}/images/${detailedFamily.totem_image}`}
          alt="Totem Image"
          className="totem-image-mock"
        />

        <div className="totem-badge-mock">
          <i className="fas fa-star" /> Sacred Symbol
        </div>
      </div>
    </div>

    <div className="totem-details-mock">
      <h3 className="totem-name-mock">
        {detailedFamily?.totem_name}
      </h3>
    </div>
  </div>
)}
       
</div>




               {/*} <div className="feature-card-mock  mt-3">
              <div className="feature-header-mock">
                <div className="section-divider-mock">
                  <div className="divider-line-mock" />
                  <div className="divider-text-mock">
                    Totem
                  </div>
                  <div className="divider-line-mock" />
                </div>

                <div className="d-flex gap-2">
                  
                  {loggedFamilyAdmin === "1" && (
                  
                      <Link to='/family-settings-edit-totem'  className="btn-edit-mock"
                      style={{ background: 'transparent', border: 'none',  }}> 
                   <i className="fas fa-pen" /></Link>
              
              )}

                  
                </div>
              </div>

              


{detailedFamily?.totem_image && (
  <div className="totem-content-mock">
    <div className="totem-image-section-mock">
      <div className="totem-image-container-mock">
        <img
          src={`${API_URL}/images/${detailedFamily.totem_image}`}
          alt="Totem Image"
          className="totem-image-mock"
        />

        <div className="totem-badge-mock">
          <i className="fas fa-star" /> Sacred Symbol
        </div>
      </div>
    </div>

    <div className="totem-details-mock">
      <h3 className="totem-name-mock">
        {detailedFamily?.totem_name}
      </h3>
    </div>
  </div>
)}
               

            </div>*/}


                </div>

               

                )
              )}
              
              </div>


              
            <div className='row' >
              <div className='col-12 col-md-12'>

              {clanDescription && (
              <div className="info-card-mock  mb-3">
                  <div className="card-header-section-mock">
                    <div className="card-icon-mock">
                      <i className="fas fa-file-alt" />
                    </div>

                    <div className="card-actions-mock">
                    {loggedFamilyAdmin === "1" && (

                        <button className="btn-edit-mock" onClick={() => openClanDescriptionModal(clanDescription)}
                        style={{ background: 'transparent', border: 'none' }}>
                        <i className="fas fa-pen"></i>
                        </button>

                      )}

                    </div>
                    </div>

                  <div className="card-title-mock"> 
                   {detailedFamily?.clan_name} Description
 
                  </div> 

                 <div className="card-value-desc-mock">
  {clanDescription.description}
</div>

                </div>

              )}

  <ReactModal isOpen={isClanModalOpen}
  onRequestClose={() => setIsClanModalOpen(false)} 
            className="Modal" overlayClassName="Overlay"
          >
            <div className="modal-header">
              <h5 className="modal-title">Edit Clan Description</h5>
              
              <button type="button" className="btn-close modalCloseButton" onClick={() => setIsClanModalOpen(false)}></button>
            </div>

            <div className="modal-body">
            <textarea
                className="form-control"
                rows="5"
                value={editClanDesc}
                onChange={(e) => setEditClanDesc(e.target.value)}
              />
            </div>

            <div className="modal-footer">

            <button
  className="btn btn-success"
  onClick={handleUpdateClanDescription}
  disabled={isUpdating}
>
  {isUpdating ? "Updating..." : "Update Description"}
</button>
             
            
            </div>
          </ReactModal>



              </div>
            </div>


             

                <div className='row'>
                  <div className='col-12 col-md-12'>

                  {loggedFamilyAdmin === "1" && (
                    
                    <div className="page-header-card mb-4">
                      <div className="d-flex justify-content-between align-items-center gap-3">
                        <div className="d-flex align-items-center gap-3">
                          <div className="header-icon-mock">
                            <i className="fas fa-tree" />
                          </div>
                          <div>
                            <div className="mock-h1 mb-0" style={{ fontSize: '1.25rem' }}>
                              Family Tree Background
                            </div>
                            <p className="mock-sub mb-0">Customize the tree background color</p>
                          </div>
                        </div>
                        <Link to="/family-settings-tree-background" className="btn btn-success btn-sm">
                          Change Family Tree Background
                        </Link>
                      </div>
                    </div>
                  )}

                  </div>
                </div>

                <div className='row'>
  <div className='col-12 col-md-12'>

    <div className="page-header-card mb-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-3">
          <div className="header-icon-mock">
            <i className="fas fa-user-shield" />
          </div>
          <div>
            <div className="mock-h1 mb-0" style={{ fontSize: '1.25rem' }}>
              Family Admins
            </div>
            <p className="mock-sub mb-0">People managing this family space</p>
          </div>
        </div>
      </div>

      {/* LOADING STATE */}
      {isLoadingAdmin && (
        <div className="text-center py-3 small text-muted">Loading admins...</div>
      )}

      {/* ERROR STATE */}
      {isErrorAdmin && (
        <div className="text-center py-3 text-danger small">Failed to load admins.</div>
      )}

      <div className="row g-3">

        {/* LIST ADMINS */}
        {familyAdminList && familyAdminList.length > 0 ? (
          familyAdminList.map((member) => (

            <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={member.id}>
              <div
                className="d-flex align-items-center gap-3 p-2 border rounded-3"
                style={{
                  background: '#fff',
                  borderColor: '#e5e7eb',
                  boxShadow: '0 2px 10px rgba(0,0,0,.05)',
                }}
              >
                <div
                  style={{
                    width: 44,
                    height: 44,
                    borderRadius: 12,
                    overflow: 'hidden',
                    background: '#f3f4f6',
                    border: '2px solid rgba(117,180,55,.35)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >

                   <ImageWithLoader2
                      src={`${API_URL}/images/${member.image_name}`}
                      placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                      fadeDuration={800}
                      blurAmount={15} 
                      alt={member.name}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                  
                </div>


                <div className="flex-grow-1">
                  <div className="fw-semibold text-truncate">{member.n_prefix} {member.name} {member.last_name}</div>
                  <div className="small text-muted text-truncate">{member.email}</div>
                </div>

                <span
                  className="badge rounded-pill"
                  style={{
                    background:
                      'linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%)',
                    color: '#fff',
                    fontWeight: 700,
                  }}
                >
                  Admin
                </span>
              </div>
            </div>

          ))
        ) : (
          // NO ADMINS
          <div className="col-12">
            <div className="text-center text-muted small py-2">
              No admins found.
            </div>
          </div>
        )}

      </div>
    </div>

  </div>
</div>

             



<div className='row'>
  <div className='col-12 col-md-12'>

  <div className="card border-0 shadow-sm rounded-4   traditions-shell">
  <div className="card-body p-3 p-md-4">
    <div className="traditions-header">
      <div className="header-icon">
        <i className="fas fa-users-cog"></i>
      </div>
      <h3 className="mb-2 fw-bold">Family Tradition Guidelines</h3>
      <p className="text-muted mb-0"></p>
    </div>

    
    {dosdontsLoading && <p>Loading...</p>}
    {dosdontsError && <p>Error loading traditions</p>}

    {!dosdontsLoading && !dosdontsError && !!traditionsDosDonts && (

      <>
      <div className="traditions-grid">
    <div className="col-12 col-lg-6">

        <div className="card border-0 shadow-sm h-100 tradition-card" style={{ borderRadius: '20px' }}>
          <div className="card-header-custom success">
            <div className="card-header-flex">
              <div className="card-title-section">
                <div className="card-icon-badge success">
                  <i className="fas fa-check-circle"></i>
                </div>
                <h5 className="card-title-text success">Do's</h5>
              </div>
              <span className="count-badge">
                {dos.length} Guidelines
              </span>
            </div>
            <p className="card-subtitle">
              Practices and behaviors that honor our family traditions
            </p>
          </div>
       <div className="card-body guideline-container card-body-custom">

            <div className="guidelines-list">

            {dos.map(item => (

                <div key={item.id} 
                  className="guideline-full guideline-item mb-3"
                >
                  <div className="guideline-icon success">
                    <i className="fas fa-check"></i>
                  </div>

                  <span className="guideline-text">
                  {item.traditions}
                  </span>

                  
                  {loggedFamilyAdmin === "1" && (
                  <div className="guideline-actions">
                    <button
                      className="action-btn edit"
                      onClick={() => openTraditionEditModal(item)}
                      title="Edit"
                    >
                      <i className="fas fa-pen"></i>
                    </button>
                    <button
                      className="action-btn delete"
                      onClick={() => handleDeleteDos(item.id)}
                      title="Remove"
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  </div>
                )}
                </div>
              ))}
            </div>

            <div className="input-section">
              <input 
                type="text" 
                className="form-control tradition-input" 
                placeholder="Add a new Do..."
                value={traditions}
                onChange={(e) => setTraditions(e.target.value)}
              />
              <button 
                className="add-btn success"
                onClick={handleAddDo}
              >
                <i className="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>

           
      </div>


    

      <div className="col-12 col-lg-6">

<div className="card border-0 shadow-sm h-100 tradition-card" style={{ borderRadius: '20px' }}>
  <div className="card-header-custom danger">
    <div className="card-header-flex">
      <div className="card-title-section">
        <div className="card-icon-badge danger">
          <i className="fas fa-times-circle"></i>
        </div>
        <h5 className="card-title-text danger">Don'ts</h5>
      </div>
      <span className="count-badge">
        {donts.length} Guidelines
      </span>
    </div>
    <p className="card-subtitle">
      Behaviors to avoid that disrespect our traditions
    </p>
  </div>
<div className="card-body guideline-container card-body-custom">

    <div className="guidelines-list">

    {donts.map(item => (


        <div key={item.id} 
          className="guideline-full guideline-item mb-3"
        >
          <div className="guideline-icon danger">
            <i className="fas fa-times"></i>
          </div>

          <span className="guideline-text">
          {item.traditions}
          </span>

          
          {loggedFamilyAdmin === "1" && (
          <div className="guideline-actions">
            <button
              className="action-btn edit"
              onClick={() => openTraditionEditModal(item)}
              title="Edit"
            >
              <i className="fas fa-pen"></i>
            </button>
            <button
              className="action-btn delete"
              onClick={() => handleDeleteDos(item.id)}
              title="Remove"
            >
              <i className="fas fa-times"></i>
            </button>
          </div>
        )}
        </div>
      ))}
    </div>

    <div className="input-section">
      <input 
        type="text" 
        className="form-control tradition-input" 
        placeholder="Add a new Don't..."
        value={traditions}
        onChange={(e) => setTraditions(e.target.value)}
      />
      <button 
        className="add-btn danger"
        onClick={handleAddDonts}
      >
        <i className="fas fa-plus"></i>
      </button>
    </div>
  </div>
</div>

   
</div>




      </div>
</>

)}



  


    </div>
    </div>   

    


    <ReactModal
  isOpen={traditionEditModalOpen}
  onRequestClose={() => setTraditionEditModalOpen(false)}
  className="Modal"
  overlayClassName="Overlay"
>
  <div className="modal-header">
    <h5 className="modal-title">Edit description</h5>
    <button
      type="button"
      className="btn-close modalCloseButton"
      onClick={() => setTraditionEditModalOpen(false)}
    ></button>
  </div>

  <div className="modal-body">
    <div className="mb-3">
      <label className="form-label">Edit description</label>
      <textarea
        className="form-control"
        rows="4"
        value={editTradition}
        onChange={(e) => setEditTradition(e.target.value)}
        placeholder="Edit Tradition"
      />
    </div>
  </div>

  <div className="modal-footer">
    <button className="btn btn-success" onClick={handleEditDos}>
      Update
    </button>
  </div>
</ReactModal>




  </div>
</div>


           

<div className='row end-page-space' >  </div>

            
          </div>
        </div>
      </div>


     
      <style>{`
:root{
  --brand: #75B437;
  --brand-600: #5fa12f;
  --brand-700: #4d8e29;
  --brand-dark: #184A2C;
  --ink: #000000;
  --bg: #EBF4ED;
  --bg-soft: #f4faf6;
}

.scrollPageContainer { min-height: 100vh; overflow-y: auto; }


.bg-light-subtle{
  background: linear-gradient(135deg, #f8fafc, #f1f5f9) !important;
  border:2px dashed #cbd5e1 !important;
}

.btn-success{
  background: linear-gradient(
    135deg,
    var(--brand) 0%,
    var(--brand-dark) 100%
  );
  border:none;
  color:#fff;
  box-shadow:0 4px 12px rgba(24,74,44,.35);
  transition: all .3s ease;
}
.btn-success:hover{
  background: linear-gradient(
    135deg,
    var(--brand-dark) 0%,
    #0f3320 100%
  );
  transform: translateY(-1px);
  box-shadow:0 8px 20px rgba(24,74,44,.45);
}

.content.container-fluid{ padding-left:1rem; padding-right:1rem; }
@media (min-width:768px){
  .content.container-fluid{ padding-left:1.5rem; padding-right:1.5rem; }
}

.btn-icon {
  --btn-bg:#f1f5f2;
  --btn-bg-hover:#e7efe9;
  --btn-border:#dfe9e2;
  background:var(--btn-bg);
  border:1px solid var(--btn-border);
  border-radius:10px;
  padding:6px 10px;
  line-height:1;
  display:inline-flex;
  align-items:center;
  justify-content:center;
  transition: background .15s ease, border-color .15s ease, transform .06s ease;
}
.btn-icon i { font-size:.9rem; }
.btn-icon:hover { background:var(--btn-bg-hover); transform: translateY(-1px); }

.chip{
  width:28px;
  height:28px;
  border-radius:9999px;
  color:#fff;
  display:inline-flex;
  align-items:center;
  justify-content:center;
}
.chip-emerald{
  background:linear-gradient(135deg,var(--brand),var(--brand-dark));
}
.chip-emerald i { color:#fff; }

/* modal header tone now matches brand */
.modal-header-green{
  background: radial-gradient(circle at 20% 20%,
    rgba(117,180,55,.08) 0%,
    rgba(24,74,44,.02) 80%);
  border-bottom:1px solid rgba(117,180,55,.25);
  padding:1rem;
}

@media (max-width:575px){
  .history-title{ font-size:1rem; }
  .history-text{ font-size:.9rem; line-height:1.4; }
  .small{ font-size:.8rem; }
  .modal-body{ padding:.75rem !important; }
  .modal-footer{ padding:.75rem 1rem; gap:.5rem; }
  .modal-footer .btn{ flex:1; }
  .form-control-sm{ padding:.45rem .7rem; font-size:.9rem; }
}

.page-header-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem 2rem 1.5rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  margin-bottom: 2rem;
  border: 1px solid #e5e7eb;
}

.top-active-card {
  position: relative;
  overflow: hidden;
  background: #fff;
}
.top-active-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-dark) 100%);
}
.top-active-head {
  border-bottom: 1px solid #eef2f7;
  padding-bottom: 10px;
}
.top-active-icon {
  width: 30px;
  height: 30px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
  color: #fff;
  box-shadow: 0 4px 12px rgba(24,74,44,.28);
}
.top-active-title {
  color: #1f2937;
}
.top-active-empty {
  min-height: 70px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.top-active-empty i {
  color: #7a8899;
}
.top-active-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  border-radius: 12px;
  border: 1px solid #edf1f5;
  margin-bottom: 8px;
  transition: all .2s ease;
}
.top-active-row:hover {
  border-color: #d7e7dc;
  box-shadow: 0 6px 16px rgba(0,0,0,.05);
}
.top-active-rank {
  border-radius: 999px;
  padding: 0.35rem 0.55rem;
}

.header-content-mock {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}
.mock-h1 {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--brand-dark);
  margin-bottom: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.header-icon-mock {
  width: 48px;
  height: 48px;
  background: linear-gradient(
    135deg,
    var(--brand) 0%,
    var(--brand-dark) 100%
  );
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  box-shadow:0 4px 12px rgba(24,74,44,.3);
}
.mock-sub {
  color: #6b7280;
  font-size: 0.95rem;
  margin: 0;
}

.btn-add-new-mock,
.btn-add-story {
  background: linear-gradient(
    135deg,
    var(--brand) 0%,
    var(--brand-dark) 100%
  );
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(24,74,44,.35);
  cursor: pointer;
}
.btn-add-new-mock:hover,
.btn-add-story:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(24,74,44,.45);
  background: linear-gradient(
    135deg,
    var(--brand-dark) 0%,
    #0f3320 100%
  );
}

@media (max-width:768px){
  .header-content-mock {
    flex-direction: column;
    align-items: stretch;
  }
  .btn-add-new-mock {
    width: 100%;
    justify-content: center;
  }
}

/* ======================= INFO GRID (Family Name / Tribe / Clan) ======================= */

.info-grid-mock {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.info-card-mock {
  background: #ffffff;
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
  border: 1px solid #e5e7eb;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.5s ease-out;
}
.info-card-mock::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 3px;
  background: linear-gradient(
    90deg,
    var(--brand) 0%,
    var(--brand-dark) 100%
  );
}
.info-card-mock:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.1);
  border-color: rgba(117,180,55,.35);
}

.card-header-section-mock {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.25rem;
}

.card-icon-mock {
  width: 40px;
  height: 40px;
  background: radial-gradient(circle at 30% 30%,
    rgba(117,180,55,.18) 0%,
    rgba(24,74,44,.08) 70%);
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--brand-dark);
  font-size: 1.1rem;
  flex-shrink: 0;
  border:2px solid rgba(117,180,55,.4);
}
.card-actions-mock {
  display: flex;
  gap: 0.5rem;
  flex-shrink: 0;
}

.btn-edit-mock {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  cursor: pointer;
  font-size: 0.85rem;
  background: #f3f4f6;
  color: #6b7280;
}
.btn-edit-mock:hover {
  background: var(--bg-soft);
  color: var(--brand-dark);
  border-color: var(--brand);
  box-shadow: 0 4px 12px rgba(24,74,44,.2);
  transform: rotate(12deg) scale(1.1);
}

.card-title-mock {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6b7280;
  margin-bottom: 0.5rem;
}
.card-value-mock {
  font-size: 1.25rem;
  font-weight: 700;
  color: #111827;
  word-wrap: break-word;
  line-height: 1.4;
}

.card-badge-mock {
  display: inline-block;
  background: radial-gradient(circle at 30% 30%,
    rgba(117,180,55,.18) 0%,
    rgba(24,74,44,.08) 70%);
  color: var(--brand-dark);
  padding: 0.35rem 0.75rem;
  border-radius: 8px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 0.5rem;
  border:1px solid rgba(117,180,55,.4);
}

/* Clan long description under clan card */
.clan-desc-mock {
  margin-top: 0.75rem;
  margin-bottom: 0;
  font-size: 0.9rem;
  line-height: 1.5;
  color: #4b5563;
  background: var(--bg-soft);
  border: 1px solid rgba(117,180,55,.25);
  border-radius: 8px;
  padding: 0.75rem .75rem;
  word-break: break-word;
  white-space: pre-wrap;
}

/* Section divider label "Totem" */
.section-divider-mock {
  display: flex;
  align-items: center;
  margin: 0.5rem 0 0 rem;
  gap: 1rem;
}
.divider-line-mock {
  flex: 1;
  height: 2px;
  background: linear-gradient(90deg, transparent, #d1d5db, transparent);
}
.divider-text-mock {
  font-size: 0.875rem;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 1px;
  padding: 0.5rem 1rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}


.card-value-desc-mock{
  font-size: 1rem;
  font-weight: 400;          /* not bold */
  color: #111827;
  line-height: 1.7;
  white-space: pre-wrap;     /* keeps line breaks */
}





/* ======================= TOTEM FEATURE CARD ======================= */

.feature-card-mock {
  background: #ffffff;
  border-radius: 20px;
  padding: 2rem;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  border: 1px solid #e5e7eb;
  margin-bottom: 2rem;
  position: relative;
  overflow: hidden;
  animation: fadeInUp 0.5s ease-out;
}
.feature-card-mock::before {
  content: '';
  position: absolute;
  top: 0; left: 0; right: 0;
  height: 5px;
  background: linear-gradient(
    90deg,
    var(--brand) 0%,
    var(--brand-dark) 100%
  );
}
.feature-header-mock {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #f3f4f6;
}

.totem-content-mock {
  display: grid;
  grid-template-columns: 280px 1fr;
  gap: 2rem;
  align-items: start;
}
.totem-image-section-mock { position: relative; }

.totem-image-container-mock {
  width: 280px;
  height: 280px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12);
  border: 3px solid rgba(117,180,55,.4);
  transition: all 0.4s ease;
  position: relative;
  background:#f9fafb;
  display:flex;
  align-items:center;
  justify-content:center;
}
.totem-image-container-mock:hover {
  transform: scale(1.05) rotate(2deg);
  box-shadow: 0 12px 48px rgba(24,74,44,.28);
  border-color: var(--brand);
}
.totem-image-mock {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.totem-image-fallback {
  font-size: .9rem;
  color:#6b7280;
  text-align:center;
}
.totem-image-fallback .fallback-text{
  background:rgba(255,255,255,0.6);
  border-radius:8px;
  padding:.5rem .75rem;
  box-shadow:0 2px 8px rgba(0,0,0,.07);
}
.totem-badge-mock {
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  padding: 0.5rem 1rem;
  border-radius: 10px;
  font-weight: 600;
  color: var(--brand-dark);
  box-shadow: 0 2px 12px rgba(0,0,0,0.1);
  font-size: 0.9rem;
  display:flex;
  align-items:center;
  gap:.5rem;
}

.totem-details-mock {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}
.totem-name-mock {
  font-size: 2rem;
  font-weight: 800;
  color: var(--brand-dark);
  margin: 0;
  line-height: 1.2;
}
.totem-description-mock {
  color: #4b5563;
  line-height: 1.7;
  font-size: 1rem;
  margin: 0;
}

.totem-attributes-mock {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 1rem;
}
.attribute-item-mock {
  background: radial-gradient(circle at 20% 20%,
    rgba(117,180,55,.08) 0%,
    rgba(24,74,44,.02) 80%);
  padding: 1rem;
  border-radius: 12px;
  border: 1px solid rgba(117,180,55,.4);
}
.attribute-label-mock {
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--brand-dark);
  letter-spacing: 0.5px;
  margin-bottom: 0.5rem;
}
.attribute-value-mock {
  font-size: 1.1rem;
  font-weight: 700;
  color: var(--brand-dark);
  word-break: break-word;
}

@media (max-width: 968px) {
  .totem-content-mock {
    grid-template-columns: 1fr;
  }
  .totem-image-container-mock {
    width: 100%;
    max-width: 280px;
    margin: 0 auto;
  }
  .totem-name-mock { font-size:1.6rem; }
}

/* Family traditions section */
.traditions-shell {
  background: linear-gradient(135deg, #f5f7fa 0%, #eef2f5 100%);
}
.traditions-header {
  background: #fff;
  border-radius: 20px;
  padding: 28px 20px;
  margin-bottom: 24px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.06);
  text-align: center;
  position: relative;
  overflow: hidden;
}
.traditions-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, var(--brand) 0%, var(--brand-dark) 100%);
}
.traditions-header .header-icon {
  width: 70px;
  height: 70px;
  margin: 0 auto 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
  box-shadow: 0 6px 20px rgba(24, 74, 44, 0.3);
  color: #fff;
  display: grid;
  place-items: center;
  font-size: 1.5rem;
}
.traditions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
}
.tradition-card {
  display: flex;
  flex-direction: column;
}
.card-header-custom {
  padding: 20px 22px 14px;
}
.card-header-custom.success {
  background: linear-gradient(135deg, #edf6ef 0%, #e4f0e8 100%);
  border-bottom: 2px solid var(--brand);
}
.card-header-custom.danger {
  background: linear-gradient(135deg, #eef4ef 0%, #e5ece7 100%);
  border-bottom: 2px solid var(--brand-600);
}
.card-header-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 8px;
}
.card-title-section {
  display: flex;
  align-items: center;
  gap: 10px;
}
.card-icon-badge {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  color: #fff;
  font-size: 1rem;
}
.card-icon-badge.success {
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
}
.card-icon-badge.danger {
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
}
.card-title-text {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
}
.card-title-text.success { color: var(--brand-dark); }
.card-title-text.danger { color: var(--brand-dark); }
.count-badge {
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%);
  color: #fff;
  padding: 5px 12px;
  border-radius: 999px;
  font-size: 0.78rem;
  font-weight: 600;
}
.card-subtitle {
  margin: 0;
  color: #4b5563;
  font-size: 0.88rem;
}
.card-body-custom {
  padding: 12px 10px 12px;
}
.guidelines-list {
  margin-bottom: 10px;
}
.guideline-item {
  display: grid !important;
  grid-template-columns: auto minmax(0, 1fr) auto;
  column-gap: 10px;
  align-items: start;
  background: #f8f9fa !important;
  border: 2px solid #e9ecef !important;
  border-radius: 14px !important;
  padding: 12px !important;
  transition: all 0.25s ease;
}
.guideline-item:hover {
  background: #fff !important;
  border-color: var(--brand) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateX(4px);
}
.guideline-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: grid;
  place-items: center;
  font-size: 0.86rem;
}
.guideline-icon.success {
  color: var(--brand-dark);
  background: linear-gradient(135deg, #d8eadf 0%, #cde3d5 100%);
}
.guideline-icon.danger {
  color: var(--brand-dark);
  background: linear-gradient(135deg, #d8eadf 0%, #cde3d5 100%);
}
.guideline-full .guideline-text {
  margin: 0 !important;
  font-size: clamp(0.94rem, 1.35vw, 1.02rem) !important;
  line-height: 1.55 !important;
  font-weight: 500 !important;
  color: #1f2937 !important;
  width: 100%;
  word-break: break-word;
}
.guideline-actions {
  display: flex;
  gap: 6px;
}
.action-btn {
  width: 31px;
  height: 31px;
  border-radius: 8px;
  border: 1px solid #d7dce3;
  background: #fff;
  display: grid;
  place-items: center;
  transition: all 0.2s ease;
  padding: 0;
}
.action-btn.edit { color: var(--brand-dark); }
.action-btn.edit:hover {
  background: #eff5f1;
  border-color: var(--brand-600);
}
.action-btn.delete { color: var(--brand-dark); }
.action-btn.delete:hover {
  background: #eff5f1;
  border-color: var(--brand-600);
}
.input-section {
  display: flex;
  gap: 8px;
  padding-top: 8px;
}
.tradition-input {
  border: 2px solid #e5e7eb !important;
  border-radius: 10px !important;
  min-height: 38px;
  font-size: 0.92rem;
}
.tradition-input:focus {
  border-color: var(--brand) !important;
  box-shadow: 0 0 0 3px rgba(117, 180, 55, 0.1) !important;
}
.add-btn {
  min-width: 46px;
  min-height: 38px;
  border: 0;
  border-radius: 10px;
  color: #fff;
  font-weight: 600;
}
.add-btn.success { background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%); }
.add-btn.danger { background: linear-gradient(135deg, var(--brand) 0%, var(--brand-dark) 100%); }

@media (max-width: 1024px) {
  .traditions-grid {
    grid-template-columns: 1fr;
    gap: 18px;
  }
}
@media (max-width: 576px) {
  .traditions-header {
    padding: 22px 14px;
  }
  .guideline-item {
    grid-template-columns: auto 1fr;
    grid-template-rows: auto auto;
    padding: 10px !important;
  }
  .guideline-actions {
    grid-column: 2;
    margin-top: 6px;
  }
  .guideline-full .guideline-text {
    font-size: 0.94rem !important;
    line-height: 1.45 !important;
  }
  .input-section {
    gap: 8px;
  }
}
`}</style>



    </div>
  );
}

export default FamilySettings;
